/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Table, Button, Space, Modal, Tooltip, Select } from "antd";
import { EditOutlined, EyeOutlined } from "@ant-design/icons";
import { plusicon, searchnormal } from "../../imagepath";
import { Link } from "react-router-dom";
import DoctorHeader from "../../../doctor/DoctorHeader";
import Sidebar from "../../Sidebar";
import { getRoleName } from "../../../utils/roles";
import moment from "moment/moment";
import apiClient from "../../../utils/apiClient";
import ChangePassword from "./ChangePassword";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faKey } from "@fortawesome/free-solid-svg-icons";
import useUser from "../../../hooks/useUser";
import useDebounce from "../../../hooks/useDebounce";
import axios from "axios";
import { baseURl } from "../../../utils/urls";
const { Option } = Select;
const RadiologistUser = () => {
  const { isSuperAdmin, isSubAdmin } = useUser();
  const [roles, setRoles] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(0);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filterInput, setFilterInput] = useState("");
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [modalState, setModalState] = useState({
    isModalOpen: false,
    id: "",
    name: "",
  });

  const debouncedFilterInput = useDebounce(filterInput, 500); // 500ms debounce delay

  const fetchRoles = async () => {
    try {
      const response = await axios.get(`${baseURl}/auth/roleList`);
      setRoles(response?.data?.roles?.rows);
    } catch (error) {
      console.log(error);
    }
  };

  const fetchCategories = async () => {
    try {
      const response = await apiClient.get("/category");
      console.log("Response669--->", response);
      setCategories(response?.data?.category?.data);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchRoles();
    fetchCategories();
  }, []);

  useEffect(() => {
    const getUsers = async () => {
      setLoading(true);
      console.log("Selected categiry-->", selectedCategory);
      try {
        const response = await apiClient.get("users", {
          params: {
            page: currentPage,
            limit,
            ...(debouncedFilterInput && { search: debouncedFilterInput }),
            ...(selectedRole && { role: selectedRole }),
            ...(selectedCategory &&
              selectedCategory !== 0 && {
                categoryId: selectedCategory,
              }),
          },
        });
        setData(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };
    getUsers();
  }, [
    currentPage,
    debouncedFilterInput,
    limit,
    selectedRole,
    selectedCategory,
  ]); // Use debouncedFilterInput instead of filterInput

  const handleOk = () => {
    setModalState({ isModalOpen: false, id: "", name: "" });
  };

  const handleCancel = () => {
    setModalState({ isModalOpen: false, id: "", name: "" });
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <>
          <h2 className="profile-image">
            <Link to="#">{record.name}</Link>
          </h2>
        </>
      ),
    },
    {
      title: "Role Name",
      dataIndex: "role",
      render: (text, record) => (
        <>
          <h2 className="profile-image">
            <Link to="#">{record["role.name"] ?? ""}</Link>
          </h2>
        </>
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
    },
    {
      title: "Modified Date",
      dataIndex: "modified_date_time",
      render: (text, record) => {
        const date = new Date(record?.modified_date_time);
        return <>{moment(date).format("DD-MM-YYYY")}</>;
      },
    },
    {
      title: "Grade",
      key: "grade",
      width: 5,
      render: (record) => record?.assignedGrade?.grade?.name ?? "-",
    },
    {
      title: "Actions",
      dataIndex: "actions",
      width: "15%",
      render: (text, record) => (
        <Space>
          {record.site_report_header && (
            <Tooltip title="Header">
              <Button
                onClick={() => {
                  window.open(record?.site_report_header, "_blank");
                }}
              >
                <EyeOutlined />
              </Button>
            </Tooltip>
          )}

          {record.site_report_footer && (
            <Tooltip title="Footer">
              <Button
                onClick={() => {
                  window.open(record?.site_report_footer, "_blank");
                }}
              >
                <EyeOutlined />
              </Button>
            </Tooltip>
          )}
          <Tooltip title="Edit">
            <Link to={`${record.id}`}>
              <Button>
                <EditOutlined />
              </Button>
            </Link>
          </Tooltip>
          {(isSuperAdmin || isSubAdmin) && (
            <Tooltip title="Change Password">
              <Button
                onClick={() =>
                  setModalState({
                    isModalOpen: true,
                    id: record.id,
                    name: record.name,
                  })
                }
              >
                <FontAwesomeIcon icon={faKey} />
              </Button>
            </Tooltip>
          )}
        </Space>
      ),
      align: "center",
    },
  ];

  return (
    <>
      <DoctorHeader />
      <Sidebar id="menu-item3" id1="menu-items3" activeClassName="staff-list" />
      <div className="page-wrapper">
        <div className="content">
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table show-entire">
                <div className="card-body cus_box">
                  <div className="page-table-header mb-2">
                    <div className="row align-items-center">
                      <div className="col">
                        <div className="doctor-table-blk">
                          <h2>Users</h2>
                          <div className="doctor-search-blk">
                            <div className="top-nav-search table-search-blk">
                              <div
                                className="d-flex"
                                style={{
                                  gap: "20px",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <Select
                                  placeholder="Select Role"
                                  value={selectedRole || undefined}
                                  allowClear
                                  onChange={(value) => {
                                    setCurrentPage(1);
                                    setSelectedRole(value || "");
                                  }}
                                  style={{ width: "100%" }}
                                >
                                  <Option value="">All</Option>

                                  {roles
                                    ?.filter(
                                      (element) =>
                                        (isSubAdmin &&
                                          element?.name !== "subadmin" &&
                                          element?.name !== "superadmin") ||
                                        (!isSubAdmin &&
                                          element?.name !== "superadmin")
                                    )
                                    ?.map((element) => (
                                      <Option
                                        key={element?.id}
                                        value={element?.name}
                                      >
                                        {getRoleName(element?.name)}
                                      </Option>
                                    ))}
                                </Select>

                                <Select
                                  placeholder="Select Category"
                                  value={selectedCategory || undefined}
                                  allowClear
                                  onChange={(value) => {
                                    setCurrentPage(1);
                                    setSelectedCategory(value || "");
                                  }}
                                  style={{ width: "100%" }}
                                >
                                  <Option value="">All</Option>

                                  {categories?.map((element) => (
                                    <Option
                                      key={element?.id}
                                      value={element?.id}
                                    >
                                      {element?.name}
                                    </Option>
                                  ))}
                                </Select>

                                <input
                                  type="text"
                                  className="form-control"
                                  placeholder="Search here"
                                  value={filterInput}
                                  onChange={(e) => {
                                    setCurrentPage(1);
                                    setFilterInput(e.target.value);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="add-group">
                              <Link
                                to="/signup"
                                className="btn btn-primary add-pluss addone_plus ms-2"
                              >
                                <img src={plusicon} alt="#" />
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tablemain_auto doctor-list">
                    <Table
                      className="manageusers_table_border"
                      pagination={{
                        total: data?.users?.total,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} entries`,
                        onChange: (page) => {
                          setCurrentPage(page);
                        },
                        showSizeChanger: true,
                        onShowSizeChange: (current, size) => setLimit(size),
                        showQuickJumper: true,
                      }}
                      columns={columns}
                      loading={loading}
                      dataSource={data?.users?.data}
                      rowKey={(record) => record.id}
                    />
                  </div>
                  <Modal
                    title={"Change Password"}
                    className="ModalFooterHide"
                    open={modalState.isModalOpen}
                    onOk={handleOk}
                    onCancel={handleCancel}
                    maskClosable={false}
                    destroyOnClose
                  >
                    <ChangePassword
                      id={modalState.id}
                      handleCancel={handleCancel}
                    />
                  </Modal>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RadiologistUser;
